import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IWallet {
  wallet_id: string;
  balance: number;
  reserved: number;
  available: number;
}

export enum WalletTransactionType {
  DEBIT,
  CREDIT,
  RESERVE,
  RESERVE_ROLLBACK,
}

export interface IWalletTransaction {
  id: string;
  operation_date: string;
  type: number;
  amount: string;
  source_type: string;
  description: string;
  balance_after: string;
  /** Ниже — поля, которых нет в ответе /wallet/transactions; читателей у них тоже нет. */
  source_id?: string;
  created_at?: string;
  wallet_id?: string;
}

interface IWalletState {
  wallet?: IWallet;
  transactions: IWalletTransaction[];
}

const initialState: IWalletState = {
  wallet: undefined,
  transactions: [],
};

export const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setTransaction: (state, action: PayloadAction<IWalletTransaction[] | []>) => {
      state.transactions = action.payload;
    },
    setWallet: (state, action: PayloadAction<IWallet | undefined>) => {
      state.wallet = action.payload;
    },
  },
});

export const { setTransaction, setWallet } = walletSlice.actions;
export default walletSlice.reducer;
